module.exports = __webpack_public_path__ + "static/media/YF09_1.ed76dfb8.jpg";